import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AppFlavour } from '@core/models/config/app-flavour';
import { environment } from '@environments/environment';

@Directive({ selector: '[ihdAllowedForAppFlavour]' })
export class AllowedForAppFlavourDirective implements OnInit {
    constructor(private elementRef: ElementRef) {}

    @Input() ihdAllowedForAppFlavour: AppFlavour;

    ngOnInit() {
        this.checkFlavour();
    }

    private checkFlavour() {
        if (
            !!this.ihdAllowedForAppFlavour &&
            this.ihdAllowedForAppFlavour !== environment.flavour
        ) {
            let el: HTMLElement = this.elementRef.nativeElement;
            el.parentNode.removeChild(el);
        }
    }
}